/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
};

/** Bed type */
export type BedType = {
  __typename?: 'BedType';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occupancy: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

/** Bed type combination item */
export type BedTypeCombinationItem = {
  __typename?: 'BedTypeCombinationItem';
  bedType: BedType;
  count: Scalars['Int']['output'];
  hotelRoomId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** Public booking model */
export type Booking = {
  __typename?: 'Booking';
  bookingDate: Scalars['String']['output'];
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  currency: CurrencyGraphQl;
  hotelId: Scalars['String']['output'];
  hotelName: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  status?: Maybe<BookingStatus>;
  token: Scalars['String']['output'];
};

/** Describe status of the booking */
export enum BookingStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  Created = 'Created',
  Failed = 'Failed',
  InProgress = 'InProgress',
  PendingConfirm = 'PendingConfirm',
  PendingPayment = 'PendingPayment',
  QuoteRequest = 'QuoteRequest'
}

/** cancellation policy graphql type */
export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  penaltyPercentage: Scalars['Float']['output'];
};

export enum CurrencyGraphQl {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmk = 'ZMK',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

export type DescriptionItemDto = {
  __typename?: 'DescriptionItemDto';
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type HotelRoomResponseDto = {
  __typename?: 'HotelRoomResponseDto';
  amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bedTypeCombinationItems: Array<BedTypeCombinationItem>;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  hotelId: Scalars['String']['output'];
  hotelRoomTranslations?: Maybe<Array<HotelRoomTranslation>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupancy: Scalars['Int']['output'];
  roomSquareFeet?: Maybe<Scalars['Int']['output']>;
  roomSquareMeters?: Maybe<Scalars['Int']['output']>;
  /** if !source provider=revolugo */
  source?: Maybe<SourceHotelRoom>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Hotel room translation */
export type HotelRoomTranslation = {
  __typename?: 'HotelRoomTranslation';
  description?: Maybe<Scalars['String']['output']>;
  locale: Lang;
  name?: Maybe<Scalars['String']['output']>;
};

export type HotelRoomingListGuestResponseDto = {
  __typename?: 'HotelRoomingListGuestResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  fullname: Scalars['String']['output'];
  hotelRoomingListId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type HotelRoomingListResponseDto = {
  __typename?: 'HotelRoomingListResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  hotelBookingId: Scalars['String']['output'];
  hotelRoom: HotelRoomResponseDto;
  hotelRoomId: Scalars['String']['output'];
  hotelRoomingListGuests: Array<HotelRoomingListGuestResponseDto>;
  id: Scalars['String']['output'];
  limitDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum Lang {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Nl = 'NL',
  Pt = 'PT'
}

export enum Locale {
  DeDe = 'de_DE',
  EnUs = 'en_US',
  EsEs = 'es_ES',
  FrFr = 'fr_FR',
  ItIt = 'it_IT',
  NlNl = 'nl_NL',
  PtPt = 'pt_PT'
}

/** Map Marker */
export type MapMarker = {
  __typename?: 'MapMarker';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  markerPicture?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  sendMagicLink: Scalars['String']['output'];
};


export type MutationSendMagicLinkArgs = {
  email: Scalars['String']['input'];
};

/** Kind of payment */
export enum PaymentAssociationResourceType {
  Booking = 'Booking',
  BookingGroup = 'BookingGroup',
  HotelContract = 'HotelContract',
  Organization = 'Organization',
  Product = 'Product'
}

export type PublicBookingGroupResponseDto = {
  __typename?: 'PublicBookingGroupResponseDto';
  bookings: Array<PublicBookingResponseDto>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency?: Maybe<CurrencyGraphQl>;
  id: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  status: BookingStatus;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxIncludedPrice?: Maybe<Scalars['Int']['output']>;
  taxes?: Maybe<Array<TaxResponseDto>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type PublicBookingResponseDto = {
  __typename?: 'PublicBookingResponseDto';
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  hotelRoomOffer: PublicHotelRoomOfferResponseDto;
  id: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  status: BookingStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type PublicEvent = {
  __typename?: 'PublicEvent';
  checkInDate?: Maybe<Scalars['DateTimeISO']['output']>;
  checkOutDate?: Maybe<Scalars['DateTimeISO']['output']>;
  eventDateFrom?: Maybe<Scalars['DateTimeISO']['output']>;
  eventDateTo?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  logoPicture?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  markerPicture?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  setting?: Maybe<PublicSetting>;
  slug: Scalars['String']['output'];
  venueDescription?: Maybe<Scalars['String']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
};

/** Computed Hotel Room */
export type PublicHotelRoom = {
  __typename?: 'PublicHotelRoom';
  /** Beds pretty */
  bedsPretty: Scalars['String']['output'];
  /** Cancellation policies */
  cancellationPolicies: Array<CancellationPolicy>;
  /** Number of rooms */
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  hotelId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  occupancy: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  richDescription?: Maybe<Scalars['String']['output']>;
};

export type PublicHotelRoomOfferResponseDto = {
  __typename?: 'PublicHotelRoomOfferResponseDto';
  breakfastCount?: Maybe<Scalars['Int']['output']>;
  cancellationPolicies: Array<CancellationPolicy>;
  count: Scalars['Int']['output'];
  hotelRooms: Array<PublicHotelRoom>;
  price: Scalars['Int']['output'];
  taxIncludedPrice: Scalars['Int']['output'];
};

export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  id: Scalars['String']['output'];
};

/** public payment graphql type */
export type PublicPayment = {
  __typename?: 'PublicPayment';
  amount: Scalars['Int']['output'];
  currency: CurrencyGraphQl;
  id: Scalars['String']['output'];
  paymentMethod: PublicPaymentMethod;
  paymentStatus: PublicPaymentStatus;
  token?: Maybe<Scalars['String']['output']>;
};

/** Payment Method */
export enum PublicPaymentMethod {
  BankTransfer = 'BankTransfer',
  CreditCard = 'CreditCard',
  Unknown = 'Unknown'
}

export type PublicPaymentResourceResponseDto = {
  __typename?: 'PublicPaymentResourceResponseDto';
  currency: CurrencyGraphQl;
  list: Array<SummaryItemDto>;
  resourceType: PaymentAssociationResourceType;
  subTotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PublicPaymentStatus {
  Confirmed = 'Confirmed',
  Failed = 'Failed',
  Pending = 'Pending'
}

export type PublicSetting = {
  __typename?: 'PublicSetting';
  colorHotelMarkerPrimary?: Maybe<Scalars['String']['output']>;
  colorHotelMarkerSecondary?: Maybe<Scalars['String']['output']>;
  colorPrimary?: Maybe<Scalars['String']['output']>;
  colorSecondary?: Maybe<Scalars['String']['output']>;
  hideAddressAutocompleteInput?: Maybe<Scalars['Boolean']['output']>;
  hideHotline?: Maybe<Scalars['Boolean']['output']>;
  mapMarkers?: Maybe<Array<MapMarker>>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  bookingGroupPublic: PublicBookingGroupResponseDto;
  bookingWithToken: Booking;
  bookingsWithToken: Array<Booking>;
  eventBySlug?: Maybe<PublicEvent>;
  hotelRoomingListsPublic: Array<HotelRoomingListResponseDto>;
  organization?: Maybe<PublicOrganization>;
  payment: PublicPayment;
  paymentResource: PublicPaymentResourceResponseDto;
  settingsBySlug?: Maybe<PublicSetting>;
};


export type QueryBookingGroupPublicArgs = {
  token: Scalars['String']['input'];
};


export type QueryBookingWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryBookingsWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryEventBySlugArgs = {
  eventSlug: Scalars['String']['input'];
  settingSlug?: InputMaybe<Scalars['String']['input']>;
  tid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHotelRoomingListsPublicArgs = {
  lang?: InputMaybe<Locale>;
  token: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  tid: Scalars['String']['input'];
};


export type QueryPaymentArgs = {
  id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryPaymentResourceArgs = {
  locale: Lang;
  token: Scalars['String']['input'];
};


export type QuerySettingsBySlugArgs = {
  organizationId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

/** Source hotel room */
export enum SourceHotelRoom {
  Expedia = 'Expedia',
  Rakuten = 'Rakuten',
  Revolugo = 'Revolugo'
}

export type SummaryItemDto = {
  __typename?: 'SummaryItemDto';
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  currency: CurrencyGraphQl;
  descriptions: Array<DescriptionItemDto>;
  price: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export enum TaxFrequency {
  PerNight = 'PerNight',
  PerStay = 'PerStay'
}

export enum TaxMode {
  PerAdult = 'PerAdult',
  PerBooking = 'PerBooking'
}

export type TaxResponseDto = {
  __typename?: 'TaxResponseDto';
  amount: Scalars['Int']['output'];
  currency?: Maybe<CurrencyGraphQl>;
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  taxFrequency: TaxFrequency;
  taxMode: TaxMode;
};
